export const CURRENCIES = {
  EUR: 6,
}